import * as constants from '../constants';
import roundedRectangle from './rounded-rectangle';

const white = 0xFFFFFF;

const cornerRadius = 3;
const len = 26;
const lineWidth = 3;
const verticalPadding = 4;
const fontSize = 24;

export const width = len;
export const height = len + verticalPadding + fontSize;

export function create( data, eventEmitter ) {
  const x = -len / 2;

  const c = new PIXI.Sprite();
  c.interactive = true;
  c.cursor = 'pointer';
  c.hitArea = new PIXI.Rectangle(x, 0, width, height);

  const nofill = roundedRectangle({ w: len, h: len, r: cornerRadius, lineWidth, lineColour: white });
  nofill.position.set(x, 0);
  c.addChild(nofill);

  const fill = roundedRectangle({ w: len, h: len, r: cornerRadius, fillColour: white });
  fill.position.set(x, 0);
  c.addChild(fill);

  const tick = new PIXI.Text(constants.tick, { font: `${ fontSize }px Flaticons Stroke`, fill: constants.darkBlue, align: 'center' });
  tick.anchor.set(0.5);
  tick.position.set(0, 16);
  c.addChild(tick);

  const label = new PIXI.Text(data.value, { font: `${ fontSize }px Open Sans`, fill: white, align: 'center' });
  label.anchor.set(0.5, 0);
  label.position.set(0, len + verticalPadding);
  c.addChild(label);

  redraw();

  c.on('pointerdown', () => {
    data.selected = !data.selected;
    eventEmitter.emit('update-selection');
  });

  eventEmitter.on('update-selection', redraw);

  function redraw() {
    fill.visible = data.selected;
    tick.visible = data.selected;
  }

  return c;
};
